import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaFormSubmitSuccessPageComponent } from './pa-form-submit-success-page.component';
import { PaFormSubmitSuccessPageRoutingModule } from './pa-form-submit-success-page-routing.module';



@NgModule({
  declarations: [
    PaFormSubmitSuccessPageComponent
  ],
  imports: [
    CommonModule,
    PaFormSubmitSuccessPageRoutingModule
  ]
})
export class PaFormSubmitSuccessPageModule { }
